import { createApp as createVueApp, createSSRApp, type Plugin } from "vue";
import { createPinia } from "pinia";
import type { RouterHistory } from "vue-router";
import App from "./App.vue";
import { createAppRouter } from "./router";
import { i18n as sharedI18n } from "@acme/i18n";

type I18nInstance = typeof sharedI18n;

export function createClientApp(
  history: RouterHistory,
  hydrate = false,
  i18n: I18nInstance = sharedI18n,
) {
  const app = hydrate ? createSSRApp(App) : createVueApp(App);
  const router = createAppRouter(history);
  const pinia = createPinia();

  app.use(router);
  app.use(i18n as unknown as Plugin);
  app.use(pinia);

  return { app, router, i18n, pinia };
}
